import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { UPDATE_USER_SIGNIN_SIGNOUT_TIME } from '../../../../utils/GraphQLAPI'
import UserIcon from '../../../images/userIcon.svg'
import { BASE_URL } from '../../../../utils/config'

interface Props {
  userInfo?: any
}

const HeaderUserMenu = ({ userInfo }: Props) => {
  const getUserParams = useParams()
  const history = useNavigate()

  const [userRole, setUserRole] = useState<string>('')
  const [urlRedirect, setUrlRidirect] = useState<any>('')

  useEffect(() => {
    if (userInfo?.userRole === 'TPV_ADMIN') {
      setUserRole('TPV Admin')
      setUrlRidirect('/tpvadmin/profile')
    } else if (userInfo?.userRole === 'USER') {
      if (userInfo.members[0].role === 'AGENT') {
        setUserRole('Agent Admin')
        setUrlRidirect('/agent/profile')
      } else if (userInfo?.members[0].role === 'SALES_ADMIN') {
        setUserRole('Sales Admin')
        setUrlRidirect('/salesadmin/profile')
      } else if (userInfo?.members[0].role === 'SYSTEM_ADMIN') {
        setUserRole('System Admin')
        setUrlRidirect('/systemadmin/profile')
      } else if (userInfo?.members[0].role === 'QC_USER') {
        setUserRole('QC User')
        setUrlRidirect('/qcuser/profile')
      }
    }
  }, [userInfo])

  // Capture Signin and Signout Time
  const [updateUserSigninSignoutTime] = useMutation(UPDATE_USER_SIGNIN_SIGNOUT_TIME, {
    variables: {
      signIn: false,
    },
  })

  const onSignOut = async () => {
    await updateUserSigninSignoutTime()
    localStorage.clear()
    sessionStorage.clear()
    history(`/${getUserParams.adminUser}/login`)
  }
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {userInfo.avatarUrl !== null ? (
              <img
                style={{ objectFit: 'cover' }}
                alt='profile'
                src={process.env.REACT_APP_IMAGE_BASE_URL + userInfo.avatarUrl}
              />
            ) : (
              <img src={UserIcon} alt='profile' />
            )}
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {userInfo?.firstName} {userInfo?.lastName}
            </div>
            <div
              className='fw-bold text-muted text-hover-primary fs-7'
              style={{ overflowWrap: 'anywhere' }}
            >
              {userInfo?.loginUsername ? userInfo?.loginUsername : userInfo?.emailId}
            </div>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={`${urlRedirect}`} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={onSignOut} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
